import type { ReactNode } from "react";

import TopHeader from "./TopHeader";

type LegalLayoutProps = {
  title: string;
  children: ReactNode;
};

const LegalLayout = ({ title, children }: LegalLayoutProps) => (
  <>
    <TopHeader />
    <main className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold mb-2">{title}</h1>
      <p className="text-sm text-muted-foreground mb-8">Last updated: May 11, 2026</p>
      <div className="space-y-8 text-gray-700 leading-relaxed">{children}</div>
      <p className="mt-10 text-sm text-muted-foreground">
        Questions?{" "}
        <a href="mailto:apitomcpconverter@gmail.com" className="underline hover:text-foreground">
          apitomcpconverter@gmail.com
        </a>
        {" · "}
        <a href="/" className="underline hover:text-foreground">
          Back to home
        </a>
      </p>
    </main>
  </>
);

export default LegalLayout;
